/* =========================================================
   INDILOOM THEME | product.js  (gallery, lightbox, variants, sticky bar, share, recommendations)
   ========================================================= */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = {};
  try { CFG = JSON.parse($('#il-config').textContent); } catch (e) {}
  var money = function (c) { return window.ilMoney ? window.ilMoney(c) : (c / 100).toFixed(2); };
  var toast = function (m) { if (window.ilToast) window.ilToast(m); };

  function initPdp(sec) {
    if (sec.ilPdp) return; sec.ilPdp = true;
    var id = sec.getAttribute('data-section');

    /* ---------- Gallery counter + dots (mobile swipe) ---------- */
    var gal = $('[data-gal]', sec), items = gal ? $$('.il-gal__item', gal) : [];
    var count = $('[data-gal-count]', sec), dots = $$('[data-gal-dots] span', sec);
    function syncGal() {
      if (!gal || !count) return;
      var i = Math.max(0, Math.min(items.length - 1, Math.round(gal.scrollLeft / (gal.clientWidth || 1))));
      count.textContent = (i + 1) + ' / ' + items.length;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    if (gal) gal.addEventListener('scroll', function () { requestAnimationFrame(syncGal); }, { passive: true });
    function showMedia(mediaId) {
      var el = gal && $('[data-media-id="' + mediaId + '"]', gal);
      if (!el) return;
      if (window.matchMedia('(min-width:1024px)').matches) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      else gal.scrollTo({ left: el.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
    }

    /* ---------- Lightbox ---------- */
    var lb = document.querySelector('[data-lb-box]');
    if (lb && gal) {
      var track = $('[data-lb-track]', lb), lbCount = $('[data-lb-count]', lb), total = track.children.length, lastFocus;
      var idx = function () { return Math.round(track.scrollLeft / (track.clientWidth || 1)); };
      var load = function (i) { [i - 1, i, i + 1].forEach(function (n) { var im = track.children[n] && track.children[n].querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } }); };
      var sync = function () { lbCount.textContent = (idx() + 1) + ' / ' + total; load(idx()); };
      var open = function (i) {
        lastFocus = document.activeElement;
        lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('il-lock');
        load(i);
        requestAnimationFrame(function () { track.scrollLeft = i * track.clientWidth; sync(); });
        $('[data-lb-close]', lb).focus();
      };
      var close = function () {
        lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('il-lock');
        if (lastFocus) lastFocus.focus({ preventScroll: true });
      };
      var go = function (d) { var i = Math.max(0, Math.min(total - 1, idx() + d)); load(i); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
      gal.addEventListener('click', function (e) { var b = e.target.closest('[data-lb]'); if (b) open(+b.getAttribute('data-lb')); });
      $('[data-lb-close]', lb).addEventListener('click', close);
      $('[data-lb-prev]', lb).addEventListener('click', function () { go(-1); });
      $('[data-lb-next]', lb).addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') go(1);
        if (e.key === 'ArrowLeft') go(-1);
      });
    }

    /* ---------- Variants ---------- */
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', sec).textContent); } catch (e) {}
    var vp = $('[data-vp]', sec);
    var formId = sec.getAttribute('data-form');
    var form = document.getElementById(formId);
    var bar = document.querySelector('[data-buybar]');
    function selected() {
      return $$('fieldset[data-opt]', vp).map(function (fs) {
        var r = $('input:checked', fs), s = $('select', fs);
        return r ? r.value : s ? s.value : null;
      });
    }
    function priceHTML(v) {
      var h = '<div class="il-price" data-price><span>' + money(v.price) + '</span>';
      if (v.compare_at_price > v.price) h += '<s>' + money(v.compare_at_price) + '</s><span class="il-price__off">' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off</span>';
      return h + '</div>';
    }
    function markAvailability(sel) {
      $$('fieldset[data-opt]', vp).forEach(function (fs, oi) {
        $$('.il-vp__opt', fs).forEach(function (o) {
          var val = $('input', o).value;
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            return v.options.every(function (ov, k) { return k === oi ? ov === val : ov === sel[k]; });
          });
          o.classList.toggle('is-na', !ok);
        });
      });
    }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
      $$('fieldset[data-opt]', vp).forEach(function (fs, k) { var l = $('[data-opt-label]', fs); if (l) l.textContent = sel[k]; });
      markAvailability(sel);
      var labels = $$('[data-atc-label]'), btns = $$('[data-atc-btn],[data-bar-atc],[data-buy-now]');
      if (!v) {
        btns.forEach(function (b) { b.disabled = true; });
        labels.forEach(function (l) { l.textContent = 'Unavailable'; });
        return;
      }
      if (form) { var inp = $('[data-variant-input]', form); if (inp) inp.value = v.id; }
      $$('[data-xs-main]', sec).forEach(function (i) { i.value = v.id; i.setAttribute('data-price', v.price); });
      $$('[data-sku]', sec).forEach(function (e) { e.textContent = v.sku || ''; });
      xsTotal();
      var pb = $('[data-price-box]', sec); if (pb) pb.innerHTML = priceHTML(v);
      $$('[data-bar-price]').forEach(function (e) { e.textContent = money(v.price); });
      var best = $('[data-best]', sec), pct = best ? +best.getAttribute('data-pct') : 0;
      if (pct) $$('[data-best-price]').forEach(function (e) { e.textContent = money(v.price - Math.floor(v.price * pct / 100)); });
      btns.forEach(function (b) { b.disabled = !v.available; });
      labels.forEach(function (l) { l.textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      sec.dispatchEvent(new CustomEvent('il:variant:change', { bubbles: true, detail: v }));
    }
    if (vp && variants.length) {
      vp.addEventListener('change', update);
      markAvailability(selected());
    }

    /* ---------- Quantity breaks (metafield custom.qty_breaks): set the form quantity ---------- */
    $$('[data-qb]', sec).forEach(function (qb) {
      qb.addEventListener('change', function (e) {
        var r = e.target.closest('input[type="radio"]'); if (!r) return;
        var f = document.getElementById(qb.getAttribute('data-form'));
        var q = f && $('input[name="quantity"]', f);
        if (q) { q.value = r.value; q.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    /* ---------- Frequently bought together (metafield custom.cross_sells): running total ---------- */
    function xsTotal() {
      $$('[data-xs]', sec).forEach(function (f) {
        var main = $('[data-xs-main]', f), cur = variants.filter(function (x) { return main && String(x.id) === main.value; })[0];
        var t = cur ? cur.price : 0;
        $$('input[type="checkbox"]:checked', f).forEach(function (c) { t += +c.getAttribute('data-price') || 0; });
        var out = $('[data-xs-total]', f); if (out) out.textContent = money(t);
      });
    }
    sec.addEventListener('change', function (e) { if (e.target.closest('[data-xs] input[type="checkbox"]')) xsTotal(); });

    /* ---------- Buy it now from the sticky bar ---------- */
    $$('[data-buy-now]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!form) return;
        b.classList.add('is-loading');
        var fd = new FormData(form);
        fetch(CFG.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { if (window.ilCheckout) { window.ilCheckout(); setTimeout(function () { b.classList.remove('is-loading'); }, 2500); } else window.location.href = (CFG.root || '/') + 'checkout'; })
          .catch(function (err) { b.classList.remove('is-loading'); toast((err && err.description) || 'Could not start checkout'); });
      });
    });

    /* ---------- Sticky buy bar ---------- */
    if (bar && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-show', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }).observe(form);
    }

    /* ---------- Share ---------- */
    var url = window.location.origin + sec.getAttribute('data-url');
    var copy = function () { var done = function () { toast('Link copied'); }; if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done(); };
    $$('[data-share]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (navigator.share) navigator.share({ title: document.title, url: url }).catch(function () {}); else copy();
      });
    });
    $$('[data-copy-link]', sec).forEach(function (b) { b.addEventListener('click', copy); });

    /* ---------- Recently viewed (read by recently viewed blocks) ---------- */
    try {
      var h = sec.getAttribute('data-handle'), list = JSON.parse(localStorage.getItem('il-recent') || '[]');
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 12);
      localStorage.setItem('il-recent', JSON.stringify(list));
    } catch (e) {}
  }

  /* ---------- Similar products (same tags) with Shopify recommendations as fallback ---------- */
  function initRecs(el) {
    if (el.ilRecs) return; el.ilRecs = true;
    var similar = function () {
      var me = el.getAttribute('data-handle'), limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
      return fetch(el.getAttribute('data-similar')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = $$('[data-similar-results] > .il-card', doc).filter(function (c) { return c.getAttribute('data-h') !== me; }).slice(0, limit);
        var grid = el.querySelector('[data-similar-grid]'), shell = el.querySelector('[data-similar-shell]');
        if (cards.length < 2 || !grid || !shell) return false;
        cards.forEach(function (c) { grid.appendChild(c); });
        shell.hidden = false;
        if (window.ilInit) window.ilInit(el);
        return true;
      }).catch(function () { return false; });
    };
    var recs = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.querySelector('.il-card')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          if (window.ilInit) window.ilInit(el);
        } else {
          var s = el.closest('.il-sec'); if (s) s.hidden = true;
        }
      }).catch(function () {});
    };
    var load = function () {
      if (!el.hasAttribute('data-similar')) { recs(); return; }
      similar().then(function (ok) { if (!ok) recs(); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else { load(); }
  }

  /* ---------- Size chart drawer (metafield custom.size_chart or tagged products) ---------- */
  function initSizeChart(d) {
    if (d.ilSc) return; d.ilSc = true;
    var data = {};
    try { data = JSON.parse($('[data-sc-data]', d).textContent); } catch (e) {}
    if (Array.isArray(data)) data = { rows: data };
    var rows = data.rows || [], sizes = data.sizes || ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
    var esc = function (x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    function render(unit) {
      $('thead', d).innerHTML = '<tr><th>Size</th>' + sizes.map(function (z) { return '<th>' + esc(z) + '</th>'; }).join('') + '</tr>';
      $('tbody', d).innerHTML = rows.map(function (r) { return '<tr><th>' + esc(r.label) + '</th>' + (r[unit] || []).map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>'; }).join('');
      $$('[data-unit]', d).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false'); });
    }
    render('cm');
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-unit]'); if (b) render(b.getAttribute('data-unit')); });
  }

  function init(scope) {
    $$('[data-pdp]', scope).forEach(initPdp);
    $$('[data-recs][data-url]', scope).forEach(initRecs);
    $$('[data-sc]', scope).forEach(initSizeChart);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
